import { render } from "./NimeeTerms.vue?vue&type=template&id=42125320&scoped=true"
import script from "./NimeeTerms.vue?vue&type=script&lang=js"
export * from "./NimeeTerms.vue?vue&type=script&lang=js"

import "./NimeeTerms.vue?vue&type=style&index=0&id=42125320&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42125320"]])

export default __exports__